/**
 * @generated SignedSource<<0fc7759b3d2fe84520f7411961647465>>
 * @relayHash 4b88ce8437584874bef00b5e698c7a10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3aae5f48673757995b85e4050688e46ad5baf435efbc45a826ea714a3ada1ec5

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "TOWNSQUARE_PROJECT" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_BOARD" | "TIMELINE_PROJECT" | "%future added value";
export type JiraJqlScopeInput = {
  backlog?: JiraJqlBacklogInput | null;
  board?: JiraJqlBoardInput | null;
  list?: JiraIssueSearchScope | null;
  plan?: JiraJqlPlanInput | null;
  project?: JiraJqlProjectInput | null;
};
export type JiraJqlBacklogInput = {
  boardId: AGG$Long;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null;
  projectKey?: string | null;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null;
};
export type JiraJqlProjectInput = {
  projectKey?: string | null;
};
export type JQLBuilderWithAIFilterRefinementQuery$variables = {
  cloudId: string;
  isFilterRefinementEnabled: boolean;
  scope?: JiraJqlScopeInput | null;
};
export type JQLBuilderWithAIFilterRefinementQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"FilterRefinement_query">;
  } | null;
};
export type JQLBuilderWithAIFilterRefinementQuery = {
  response: JQLBuilderWithAIFilterRefinementQuery$data;
  variables: JQLBuilderWithAIFilterRefinementQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isFilterRefinementEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scope"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isFilterRefinementEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "assignees",
                    "value": 50
                  },
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "FilterRefinement_query"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isFilterRefinementEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v1/*: any*/)
                ],
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 50
                      },
                      {
                        "kind": "Literal",
                        "name": "jqlTerm",
                        "value": "assignee"
                      },
                      (v2/*: any*/)
                    ],
                    "concreteType": "JiraJqlFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "fieldValues",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraJqlFieldValueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "appType"
                                          }
                                        ],
                                        "type": "AppUser"
                                      },
                                      (v4/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "JiraJqlUserFieldValue"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3aae5f48673757995b85e4050688e46ad5baf435efbc45a826ea714a3ada1ec5",
    "metadata": {},
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8fb680426a5ff765df83b3dde9091a09";

export default node;
